import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MobileNavDrawer, Sidebar } from './Sidebar';
import { MobileTopBar } from './MobileTopBar';
import { Softphone } from '../softphone/Softphone';
import { WhatsappSocketInit } from '../whatsapp/WhatsappSocketInit';
import { SmsSocketInit } from '../sms/SmsSocketInit';
import { AiBalanceBanner } from './AiBalanceBanner';

export function Layout(): JSX.Element {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex h-screen flex-col sm:flex-row overflow-hidden">
      <Sidebar />
      <MobileNavDrawer open={navOpen} onClose={() => setNavOpen(false)} />

      <div className="flex flex-1 min-w-0 flex-col overflow-hidden">
        <MobileTopBar onOpenNav={() => setNavOpen(true)} />
        <AiBalanceBanner />
        <main className="flex-1 scroll-area bg-ink-50 p-4 sm:p-6 pb-20 sm:pb-6">
          <Outlet />
        </main>
      </div>

      <WhatsappSocketInit />
      <SmsSocketInit />
      <Softphone />
    </div>
  );
}
